// extracted by mini-css-extract-plugin
export var productImage = "_q0-1";
export var viewLink = "_q0-2";
export var wishlistItem = "_q0-0";